"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import type { OutsetaGlobal } from "@/interfaces/outseta";
import { trackUserRegister, trackUserSignup } from "@/lib/gtm";
import { useEffect, useState } from "react";

declare global {
  interface Window {
    Outseta?: OutsetaGlobal;
  }
}

export default function AuthPage() {
  const [activeTab, setActiveTab] = useState("login");

  useEffect(() => {
    if (window.Outseta) {
      window.Outseta.auth.open({
        widgetMode: activeTab === "login" ? "login" : "register",
        authenticationCallbackUrl: `${process.env.NEXT_PUBLIC_APP_URL ? process.env.NEXT_PUBLIC_APP_URL : "https://" + process.env.VERCEL_BRANCH_URL}/api/webhooks/outseta`,
        skipPlanOptions: activeTab === "register",
        planPaymentTerm: activeTab === "register" ? "month" : undefined
      });
    }
  }, [activeTab]); // Re-run when tab changes

  useEffect(() => {
    if (window.Outseta) {
      window.Outseta.on("signup", async (...params) => {
        console.log("Signup event detected:", params);
        const user = params[0] as any;
        const person = user?.PersonAccount[0]?.Person;
        if (person) {
          trackUserSignup({
            email: person?.Email,
            name: person?.FullName || [person?.FirstName, person?.LastName].filter(Boolean).join(" ")
          });
        }
      });

      window.Outseta.on("signup.preRegister", async (...params) => {
        console.log("Preregister event detected:", params);
        const user = params[0] as any;
        const person = user?.PersonAccount[0]?.Person;
        if (person) {
          trackUserRegister({
            email: person?.Email,
            name: person?.FullName || [person?.FirstName, person?.LastName].filter(Boolean).join(" ")
          });
        }
      });
    }
  }, []); // Re-run when tab changes

  return (
    <Card className="mx-auto w-full max-w-md">
      <CardHeader>
        <CardTitle>Welcome Back</CardTitle>
        <CardDescription>Login to your account or create a new one to get started</CardDescription>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="relative grid w-full grid-cols-2">
            <TabsTrigger
              value="login"
              className="data-[state=active]:text-foreground relative z-10 data-[state=active]:bg-transparent"
            >
              Login
            </TabsTrigger>
            <TabsTrigger
              value="register"
              className="data-[state=active]:text-foreground relative z-10 data-[state=active]:bg-transparent"
            >
              Register
            </TabsTrigger>
            <div
              className={`bg-primary/10 absolute h-full w-1/2 rounded-md transition-all duration-300 ease-in-out ${
                activeTab === "login" ? "translate-x-0" : "translate-x-full"
              }`}
            />
          </TabsList>
          <div className="mt-6">
            <div className="o-auth-embed" />
          </div>
        </Tabs>
      </CardContent>
    </Card>
  );
}
